import React, { useId } from 'react';

export function AllItemsIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  const clipId = useId();
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.3346 1.66766V10.3607L10.8672 17.82C10.7057 17.9817 10.5135 18.1101 10.3024 18.1976C10.0914 18.285 9.8651 18.3294 9.63672 18.3294C9.40829 18.3294 9.18204 18.2851 8.97103 18.1976C8.75996 18.1101 8.56773 17.9817 8.40625 17.82L2.17415 11.5863C1.85032 11.2605 1.66797 10.82 1.66797 10.3607C1.66807 9.9015 1.85041 9.46078 2.17415 9.13511L9.6416 1.66766H18.3346Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.3346 1.66766V10.3607L10.8672 17.82C10.7057 17.9817 10.5135 18.1101 10.3024 18.1976C10.0914 18.285 9.8651 18.3294 9.63672 18.3294C9.40829 18.3294 9.18204 18.2851 8.97103 18.1976C8.75996 18.1101 8.56773 17.9817 8.40625 17.82L2.17415 11.5863C1.85032 11.2605 1.66797 10.82 1.66797 10.3607C1.66807 9.9015 1.85041 9.46078 2.17415 9.13511L9.6416 1.66766H18.3346Z'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.668 6.67497C11.668 5.75476 12.4142 5.00879 13.3346 5.00879C14.2551 5.00879 15.0013 5.75476 15.0013 6.67497C15.0013 7.59517 14.2551 8.34115 13.3346 8.34115C12.4142 8.34115 11.668 7.59517 11.668 6.67497Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
